import { Link } from "react-router-dom";
import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2rem;

  h2 {
    display: flex;
    flex-direction: row;
  }

  span {
    display: flex;
    flex-direction: row;

    img {
      width: 1.5rem;
      height: 1.5rem;
    }

    button {
      background: transparent;
    }

    h4 {
      margin-right: 1.1875rem;
      margin-left: 1.5rem;
      font-weight: 500;
      font-size: 1.25rem;
      line-height: 1.875rem;
    }

    h4:before {
      content: "|";
      margin-right: 1.5rem;
      color: var(--grey-300);
    }
  }
`;

export const AdminFlag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.5625rem 0.75;
  width: 6.5rem;
  height: 2rem;
  color: var(--primary);
  background: var(--darker-primary);
  border-radius: 6.25rem;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 0.75rem;
  line-height: 0.875rem;
  margin-left: 2rem;
`;

export const ProfileLink = styled(Link)`
  svg {
    path {
      stroke: var(--primary);
    }
  }
`;
